import { useCallback, useContext, useEffect, useState } from "react";
import "./DispatchListPage.scss";
import * as orderService from "../../Services/Http/OrderService";
import { OrderList } from "../../Models/OrderList";
import { ApiError } from "../../Models/ApiError";
import { ChangeStatusRequest } from "../../Models/ChangeStatusRequest";
import { TransHeaderResponse } from "../../Models/TransHeaderResponse";
import OrderListComponent from "../../Components/OrderListComponent/OrderListComponent";
import { Order } from "../../Models/Order";
import { dataContext } from "../../Context/contextProvider";

const DispatchListPage = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const dataStore = useContext(dataContext);

  const bindGrid = useCallback(() => {
    orderService
      .getExistingOrdersForDispatchAPI(dataStore.serverUrl || "", dataStore.dbKey || "")
      .then((resp: OrderList) => {
        if (resp) {
          setOrders([...resp.result!]);
        } else {
          setOrders([]);
        }
      })
      .catch((err: ApiError) => {
        //toast.error(err.message); //error already handled in error handler
      });
  }, [dataStore.dbKey, dataStore.serverUrl]);

  useEffect(() => {
    bindGrid();
  }, [bindGrid]);

  const handleSetModalResult = (changeStatusRequest: ChangeStatusRequest): Promise<TransHeaderResponse> => {
    return new Promise<TransHeaderResponse>((resolve, reject) => {
      orderService
        .setOrderDispatchStatusAPI(changeStatusRequest, dataStore.serverUrl || "", dataStore.dbKey || "")
        .then((resp: TransHeaderResponse) => {
          bindGrid();
          resolve(resp);
        })
        .catch((err: ApiError) => {
          bindGrid();
          reject(err);
        });
    });
  };
  return <OrderListComponent orderArr={orders} modalTitle="Have the goods been dispatched?" onSetModalResult={handleSetModalResult} />;
};

export default DispatchListPage;
